import { getDynamicPromotionCode, getPromotionDetail } from '@src/api'

let promotionCode;
let promotionId;

export async function getPromitionCode(activity){
  if(!promotionCode) {
    promotionCode = await getDynamicPromotionCode(activity)
  }
  return promotionCode
}

export async function getPromitionId(params){
  if(!promotionId) {
    const promotionCode = await getPromitionCode(params.activity)
    if (!promotionCode) return;
    const promotionInfo = await getPromotionDetail({
      codeValue: promotionCode,
      goodsId: params.goodsId,
      payFrequencyType: params.payFrequencyType,
      planId: params.planId
    })
    promotionId = promotionInfo?.promotionId
  }
  return promotionId
}